/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from "react";

import { CardsStatisticsAge0a10Fem } from "./Feminine/CardsStatisticsAge0a10Fem";
import { useThemeMode } from "../../../../../_metronic/partials";
import { CardsStatisticsAge11a18Fem } from "./Feminine/CardsStatisticsAge11a18Fem";
import { CardsStatisticsAge18a30Fem } from "./Feminine/CardsStatisticsAge18a30Fem";
import { CardsStatisticsAge31Fem } from "./Feminine/CardsStatisticsAge31Fem";
import { CardsStatisticsAge0a10Masc } from "./Masculine/CardsStatisticsAge0a10Masc";
import { CardsStatisticsAge11a18Masc } from "./Masculine/CardsStatisticsAge11a18Masc";
import { CardsStatisticsAge18a30Masc } from "./Masculine/CardsStatisticsAge18a30Masc";
import { CardsStatisticsAge31Masc } from "./Masculine/CardsStatisticsAge31Masc";
import { useIntl } from "react-intl";

type Props = {
  className: string;
  chartSize?: number;
  chartLine?: number;
  chartRotate?: number;
};

const CardsStatisticsGender: FC<Props> = ({
  className,
  chartSize = 120,
  chartLine = 10,
  chartRotate = 0,
}) => {
  // const chartRef = useRef<HTMLDivElement | null>(null);
  const { mode } = useThemeMode();
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const intl = useIntl();

  return (
    <div className={`card card-flush ${className}`}>
      <div className="card-title d-flex flex-column align-items-center justify-content-center pt-5 pb-5">
        <span className="fs-2hx fw-bold text-dark me-2 lh-1 ls-n2 mb-3">
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.GENDER",
          })}
        </span>
        <div className="w-100 border-bottom border-dark mb-1"></div>
        <div
          id="gender-carousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="text-center">
                <label className="">
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MASCULINE",
                  })}
                </label>
                <div className="row text-center justify-content-center">
                  <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                    <CardsStatisticsAge0a10Fem className="" />
                  </div>
                  <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                    <CardsStatisticsAge11a18Fem className="" />
                  </div>
                  <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                    <CardsStatisticsAge18a30Fem className="" />
                  </div>
                  <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                    <CardsStatisticsAge31Fem className="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="text-center">
                <label className="d-block w-100">
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.FEMININE",
                  })}
                </label>
                <div className="row text-center justify-content-center">
                  <div className="row text-center justify-content-center">
                    <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                      <CardsStatisticsAge0a10Masc className="" />
                    </div>
                    <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                      <CardsStatisticsAge11a18Masc className="" />
                    </div>
                    <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                      <CardsStatisticsAge18a30Masc className="" />
                    </div>
                    <div className="col-md-5 col-lg-5 col-xl-5 col-xxl-5 m-1 border">
                      <CardsStatisticsAge31Masc className="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#gender-carousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#gender-carousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export { CardsStatisticsGender };
